const SewerageActivity = {
  A0: { label: 'Popravka postojeće kanalizacijske cijevi', value: 0 },
  A1: { label: 'Zamjena dijela kanalizacijskog cjevovoda', value: 1 },
  A2: { label: 'Pregled glavnog kanalizacijskog kolektora', value: 2 },
  A3: { label: 'Izgradnja novog kanalizacijskog priključka', value: 3 },
  A4: {
    label: 'Proštopavanje kanalizacije uređajem za proštopavanje',
    value: 4,
  },
  A5: {
    label: 'Odčepljivanje začepljene sanitarne kanalizacije potrošača',
    value: 5,
  },
  A6: { label: 'Čišćenje kišnog preliva od taloga i materijala', value: 6 },
  A7: { label: 'Pregled priključaka kanalizacije', value: 7 },
  A8: { label: 'Odčepljenje kanalizacije', value: 8 },
  A9: { label: 'Zamjena poklopca kanalizacionog šahta', value: 9 },
  A10: { label: 'Crpljenje taloga i materijala iz šahta', value: 10 },
  A11: {
    label: 'Građevinska popravka oštećenog kanalizacijskog šahta',
    value: 11,
  },
  A12: { label: 'Izgradnja novog kanalizacijskog šahta', value: 12 },
  A13: { label: 'Rutinsko održavanje šahta', value: 13 },
  A14: { label: 'Radovi na deratizaciji', value: 14 },
  A15: {
    label: 'Izdizanje i spuštanje poklopca kanalizacijskog šahta',
    value: 15,
  },
  A16: { label: 'Popravka slivnika', value: 16 },
  A17: { label: 'Zamjena slivničke rešetke', value: 17 },
  A18: { label: 'Čišćenje slivnika', value: 18 },
  A19: { label: 'Ostalo', value: 19 },
};

export default SewerageActivity;
